import { replacePersonaPlaceholders } from "../adonis.helpers";
import { useAdonisChat } from "../AdonisChatProvider/AdonisChatProvider";

import { getPersonaImage } from "./../assets/getPersonaImage";

interface AdonisShopCTAText {
  chat_box: string;
  chat_submit: string;
}

type AdonisCTAVariation2Props = {
  readonly onClick: () => void;
  readonly ctaText?: AdonisShopCTAText;
};

const AdonisCTAVariation2 = ({
  onClick,
  ctaText,
}: AdonisCTAVariation2Props) => {
  const { persona } = useAdonisChat();

  const defaultText = {
    chat_box: "Not sure where to start?",
    chat_submit: `ASK {name}`,
  };

  const text = ctaText
    ? {
        chat_box: replacePersonaPlaceholders(
          ctaText.chat_box || defaultText.chat_box,
          persona
        ),
        chat_submit: replacePersonaPlaceholders(
          ctaText.chat_submit || defaultText.chat_submit,
          persona
        ),
      }
    : {
        chat_box: replacePersonaPlaceholders(defaultText.chat_box, persona),
        chat_submit: replacePersonaPlaceholders(
          defaultText.chat_submit,
          persona
        ),
      };
  return (
    <button
      className="relative box-border flex h-[50px] w-full cursor-pointer items-center rounded-full
       border-[2px] border-[#BDA280] bg-white px-2 py-2 shadow-[0px_4px_16px_rgba(0,0,0,0.1)]"
      onClick={onClick}
    >
      <img
        className="absolute bottom-[-6px] left-2 h-[75px] w-[66px] translate-y-[3px] object-contain"
        src={getPersonaImage(persona?.name).clear}
        alt={persona.name ?? "Adonis"}
      />
      <div className="flex w-full items-center justify-between">
        <div className="pl-[65px] pr-1 font-sans text-body2 text-[#999999]">
          {text.chat_box}
        </div>
        <p className="relative left-1 whitespace-nowrap rounded-full bg-[#BDA280] p-2.5 font-sans text-bold3 text-white">
          {text.chat_submit}
        </p>
      </div>
    </button>
  );
};

export default AdonisCTAVariation2;
